import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    loading: 'Please Wait a Moment...',
    empty: 'You Have No Active Positions',
  },
};
